import React, { useCallback, useState } from 'react';
import AgentCard from '../../components/AgentCard/AgentCard';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Email } from '../../images/email.svg';
import './executive.scss';
import '../../components/TeamBox/teambox.scss';
import { useEffect } from 'react';
import base from '../../apis';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import { useRef } from 'react';
import Select from 'react-select';
import { MdDelete } from 'react-icons/md';
import { Modal, TextInput } from '@mantine/core';
import { Grid } from '@mui/material';
import { marketerOptions } from '../../constants';
import { Select as ManSelect, Button as ManButton } from '@mantine/core';

//array of months in a year as object with keys value and key
const months = [
  { value: -1, label: 'All' },
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
];
const selectStyles = {
  container: (provided) => ({
    ...provided,
    width: '200px',
  }),
};

const allowed = ['mark-execs', 'snr-mark-execs'];
const Executive = () => {
  const navigate = useNavigate();
  const { type } = useParams();

  const title2 = type === 'snr-mark-execs' ? 'Senior Market Executive List' : 'Market Executive List';
  const btntext = type === 'snr-mark-execs' ? '+ Add a Snr Marketing Executive' : '+ Add a Marketing Executive';
  const title = type === 'snr-mark-execs' ? 'Senior Marketing' : 'Marketing';
  const [executives, setExecutives] = useState([]);
  const [searchParams, setSearchParams] = useState({
    name: '',
    dateHired: { value: -1, label: 'All' },
  });

  const EXECUTIVES = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedMarketer, setSelectedMarketer] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const url = type === 'snr-mark-execs' ? '/operations/snr_marketers/' : '/operations/marketers/';

  const getExecs = useCallback(() => {
    setExecutives([]);
    EXECUTIVES.current = [];
    setExecutives(EXECUTIVES.current);
    setIsLoading(true);

    base
      .get(url)
      .then((res) => {
        setExecutives(res.data);
        EXECUTIVES.current = res.data;
        if (res.data?.length === 0) toast.warn(`No ${title} Executives found`);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(`Error Loading ${title} Executives`);
      });
  }, [title, url]);

  useEffect(() => {
    if (!allowed.includes(type)) {
      navigate('/404');
    }
    getExecs();
  }, [getExecs, navigate, type]);

  const onChangeSearchParams = (e) => {
    const { name, value } = e.target;
    setSearchParams((prevState) => ({ ...prevState, [name]: value }));
  };

  const onSearch = (e) => {
    e.preventDefault();

    if (searchParams.name === '' && searchParams.dateHired.value === -1) {
      setExecutives(EXECUTIVES.current);
      return;
    }

    const filtered = EXECUTIVES.current.filter((exec) => {
      const { name, dateHired } = searchParams;
      const execName = exec.user.first_name + exec.user.last_name;
      const email = exec.user.email;
      if (
        name !== '' &&
        (execName.toLowerCase().includes(name.toLowerCase()) || email.toLowerCase().includes(name.toLowerCase()))
      ) {
        return true;
      }
      if (exec.hiring_date) {
        const date = new Date(exec.hiring_date);
        const month = date.getMonth();
        if (dateHired.value !== -1 && month === dateHired.value) {
          return true;
        }
      }
      return false;
    });
    if (filtered.length === 0) {
      toast.warn(`No ${title} Executives found`);
    }
    setExecutives(filtered);
  };

  const handleClick = (agent) => {
    setSelectedMarketer(agent);
    setDetailsOpen(true);
  };

  const handleDelete = (item) => {
    setDeleteOpen(true);
    setSelectedMarketer(item);
  };

  const onConfirmDelete = () => {
    setIsLoading(true);

    base
      .delete(`operations/delete-user/${selectedMarketer.user.id}/`)
      .then(({ data }) => {
        toast.success(`Successfully deleted ${title} Executive`);
        const newList = executives.filter((exec) => exec.id !== selectedMarketer.id);
        setExecutives(newList);
        EXECUTIVES.current = [...newList];

        setDeleteOpen(false);
      })
      .catch((err) => {
        toast.error(`Error Deleting ${title} Executive`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleEdit = () => {
    const { id, category, address, phone } = selectedMarketer;
    if ((type === 'snr-mark-execs' ? false : !category) || !address || !phone) {
      toast.error(`Please fill all fields`);
      return;
    }
    setIsLoading(true);
    base
      .patch(url + id + '/', {
        category,
        address,
        phone,
      })
      .then(({ data }) => {
        toast.success(`Successfully updated ${title} Executive`);
        setDetailsOpen(false);
        getExecs();
      })
      .catch((err) => {
        toast.error(`Error updating ${title} Executive`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (!allowed.includes(type)) {
    return <Navigate to="/404" replace={true} state={{ from: '/operations-overview' }} />;
  }

  return (
    <>
      {isLoading && <Spinner />}
      <Modal title="Confirm Delete" opened={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <p>
          Are you sure you want to delete{' '}
          <b>
            {selectedMarketer?.user?.first_name} {selectedMarketer?.user?.last_name}
          </b>
          ?
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <ManButton onClick={() => setDeleteOpen(false)}>Cancel </ManButton>
          <ManButton onClick={onConfirmDelete} color="red">
            Confirm
          </ManButton>
        </div>
      </Modal>
      <Modal
        opened={detailsOpen}
        title={selectedMarketer?.corporate_id}
        onClose={() => setDetailsOpen(false)}
        size="lg">
        <Grid container spacing={2}>
          <Grid item xl={6}>
            <TextInput
              placeholder="First name"
              label="First name"
              disabled
              value={selectedMarketer?.user.first_name}
              onChange={(e) =>
                setSelectedMarketer((cur) => ({ ...cur, user: { ...cur.user, first_name: e.target.value } }))
              }
            />
          </Grid>
          <Grid item xl={6}>
            <TextInput
              placeholder="Last name"
              disabled
              label="First name"
              value={selectedMarketer?.user.last_name}
              onChange={(e) =>
                setSelectedMarketer((cur) => ({ ...cur, user: { ...cur.user, last_name: e.target.value } }))
              }
            />
          </Grid>
          <Grid item xl={12}>
            <TextInput
              placeholder="Address"
              label="Address"
              value={selectedMarketer?.address}
              onChange={(e) => setSelectedMarketer((cur) => ({ ...cur, address: e.target.value }))}
            />
          </Grid>
          <Grid item xl={6}>
            <TextInput placeholder="Email" disabled label="Email" value={selectedMarketer?.user.email} />
          </Grid>
          <Grid item xl={6}>
            <TextInput
              placeholder="Phone Number"
              label="Phone Number"
              value={selectedMarketer?.phone}
              onChange={(e) => setSelectedMarketer((cur) => ({ ...cur, phone: e.target.value }))}
            />
          </Grid>
          {selectedMarketer?.user.role === 'marketer' && (
            <Grid item xl={6}>
              <ManSelect
                label="Category"
                placeholder="Category"
                data={marketerOptions}
                value={selectedMarketer?.category}
                onChange={(value) => setSelectedMarketer((cur) => ({ ...cur, category: value }))}
              />
            </Grid>
          )}
        </Grid>
        <ManButton sx={{ display: 'block', marginLeft: 'auto', marginTop: '10px' }} onClick={handleEdit}>
          Save
        </ManButton>
      </Modal>
      <div className="executive">
        <div className="top_section">
          <div className="left">
            <Button
              onClick={() => navigate('add')}
              type="submit"
              style={{
                width: 'fit-content',
                fontSize: '16px',
                padding: '10px 20px',
                color: 'var(--primary-color)',
                backgroundColor: 'white',
                display: 'block',
                marginLeft: 'auto',
                marginTop: '0',
              }}
              text={btntext}
            />
          </div>
          <form className="right">
            <Input
              placeholder="By name or email"
              style={{ fontSize: '16px', padding: '9px 20px' }}
              type="search"
              name="name"
              fullStyles={{ marginTop: '0' }}
              onChange={onChangeSearchParams}
            />
            <Select
              isSearchable={false}
              options={months}
              placeholder="Filter by"
              value={searchParams.dateHired}
              onChange={(option) => setSearchParams({ ...searchParams, dateHired: option })}
              styles={selectStyles}
            />
            <Button
              type="submit"
              style={{
                width: 'fit-content',
                fontSize: '16px',
                padding: '9px 20px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                display: 'block',
                marginTop: '0',
              }}
              text="Filter"
              onClick={onSearch}
            />
          </form>
        </div>

        <div>
          <p className="cards_title">
            {title2}({executives.length})
          </p>
        </div>
        <div className="cards_section">
          {executives.map((item) => (
            <AgentCardMod
              key={item?.user?.id}
              {...item}
              onDetails={() => handleClick(item)}
              onDelete={() => handleDelete(item)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Executive;

const AgentCardMod = ({ user: { first_name, last_name, email }, onDetails, onDelete }) => {
  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <AgentCard Style={{ paddingRight: '40px', position: 'relative' }} onClick={onDetails}>
      <div className="vmitem">
        <span className="agent_name">
          {first_name} {last_name}
        </span>
        <span className="agent_info">
          <Email />
          &nbsp;&nbsp;&nbsp;&nbsp;{email}
        </span>
        <MdDelete className="delete-icon" size={20} onClick={handleDelete} />
      </div>
    </AgentCard>
  );
};
